import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ContextMenu } from 'components/context-menu/context-menu';
import TableList from 'components/TableList';
import * as LotActionTypes from '../constants';
import {AppSettings} from '../../constants';

class MangeLotLocations extends Component {
    static propTypes = {
      dispatch: PropTypes.func,
      lotId: PropTypes.any,
      LotLocations: PropTypes.array,
      HomeownerLots: PropTypes.array
    }

    constructor(prop) {
      super(prop);
    }

    componentDidMount() {
      this.onBindLotLocation();
    }

    componentWillUnmount() {
      this.props.dispatch({
        type: LotActionTypes.RESET_LOT_LOCATIONS
      });
    }

    onBindLotLocation = () => {
      const { lotId } = this.props;

      if (AppSettings.clientTypeValue === 'Builder') {
        this.props.dispatch({
          type: LotActionTypes.GET_LOT_LOCATIONS_ASYNC,
          params: { lotId }
        });
      } else {
        if (!this.props.HomeownerLots.length) {
          this.onGetBuilderProfile();
        } else {
          const lotFound = this.props.HomeownerLots.find(item => item.lot.id === lotId);

          if (lotFound) {
            this.onBindHomeownerLotLocation(lotFound.builderProfile);
          }

          else { this.onGetBuilderProfile(); }
        }
      }
    }

    onBindHomeownerLotLocation = (builderProfile) => {
      const { lotId } = this.props;

      this.props.dispatch({
        type: LotActionTypes.GET_HOMEOWNER_LOT_LOCATIONS_ASYNC,
        params: {
          lotId,
          builderHost: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        }
      });

    }

    onGetBuilderProfile = () => {
      const { lotId } = this.props;

      this.props.dispatch({
        type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
        params: { lotId },
        callbackGetBuilderProfile: (builderProfile) => {
          this.onBindHomeownerLotLocation(builderProfile);
        }
      });
    }

    render() {
      const data = (this.props.LotLocations.constructor === Array) ? this.props.LotLocations : [];

      const column = [
        { field: 'id', header: 'id', hidden: true, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left' },
        { field: 'name', header: 'Name', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left'}
      ];

      const options = {
        defaultSortName: 'name',
        defaultSortOrder: 'ascending'
      };

      return <div className='ownership-history-wrapper'>
        <TableList
          column={column}
          defaultParams={options}
          data={data}
          options={options}
          pagination={false}
        />
        <ContextMenu ref={(ref) => { this.cxtMenu = ref; }} />
      </div>;
    }
}

const mapStateToProps = (state) => {
  return {
    LotLocations: state.LotStore.LotLocations,
    HomeownerLots: state.LotStore.HomeownerLots
  };
};

export default connect(mapStateToProps)(MangeLotLocations);




// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view-locations.js